import React, { Component } from 'react';

import { reduxForm, Field } from 'redux-form';

import FlatButton from 'material-ui/FlatButton';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

import ColorPicker from 'components/shared/colorHelperRedux';

import { getTranslatedString } from 'helpers/i18n';

class ColorUploaderForm extends Component {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <div style={{ margin: '10px 0' }}>
          <Field
            name="accent_color"
            component={ColorPicker}
            selectedColor={this.props.selectedColor}
            onColorChange={color => {
              this.props.change('accent_color', color);
            }}
          />
        </div>
        <div className="row" style={{ textAlign: 'center', marginBottom: '15px' }}>
          <FlatButton
            type="submit"
            disabled={this.props.submitting}
            style={{
              color: 'white',
              backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
            }}
          >
            {getTranslatedString('landLordPortal.colorUpLoaderForm.update')}
          </FlatButton>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'color_selector',
  enableReinitialize: true,
})(ColorUploaderForm);
